/* ===========================================================
   Sticky Buy Bar (Universal) — Guided UX Suite
   Overlay removed per request
   -----------------------------------------------------------
   v2.6 — 2025-09-16
   =========================================================== */

(function () {
  // Only run on product pages
  const isProduct = document.body.classList.contains('template-product') ||
                    document.querySelector('form[action*="/cart/add"]');
  if (!isProduct) return;

  // Guard (set only on product pages)
  if (window.__stickyCartInit) return;
  window.__stickyCartInit = true;

  /* ---------------- DOM helpers ---------------- */
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------------- TEPO hooks ---------------- */
  function getTepoRoot() {
    return document.querySelector('[id^="tcustomizer-form-container-"]') ||
           document.querySelector('.tcustomizer-product-form') ||
           document.querySelector('.tcustomizer-widget') ||
           document.querySelector('.tepo-product-options, .tepo-container, [data-app="tepo-product-options"]');
  }
  function getTepoSubmit() {
    return document.getElementById('tcustomizer-add') ||
           document.querySelector('.tcustomizer-overlap-button') ||
           (getTepoRoot() && getTepoRoot().querySelector('.tcustomizer-overlap-button'));
  }

  /* ---------------- Price helpers ---------------- */
  const priceSelectors = [
    '.tcustomizer-price-addons',
    '.price .price-item--final',
    '.price__container .price-item--final',
    '[data-product-price]',
    '.tepo-total-price',
    '[data-tepo-total]'
  ];
  function readLivePriceRaw() {
    for (const sel of priceSelectors) {
      const el = document.querySelector(sel);
      if (el && el.textContent.trim()) return el.textContent.trim();
    }
    const wrap = document.querySelector('.price');
    if (wrap) return (wrap.textContent || '').trim();
    return '—';
  }
  function prettyMoney(text) {
    if (!text) return '—';
    const m = text.match(/(?:CA)?\$\s?[\d,.]+/i) || text.match(/\$\s?[\d,.]+/);
    return m ? m[0].replace(/\s+/g, '') : text;
  }

  /* ---------------- Product form + qty ---------------- */
  const productForm = document.querySelector('form[action*="/cart/add"], form.product-form');
  const qtyInput = productForm ? (productForm.querySelector('input[name="quantity"]') || productForm.querySelector('quantity-input input')) : null;

  function getQty(){ return qtyInput ? Math.max(1, parseInt(qtyInput.value || '1', 10)) : 1; }
  function setQty(n) {
    if (!qtyInput) return;
    const v = Math.max(1, n|0);
    if (+qtyInput.value !== v) {
      qtyInput.value = v;
      qtyInput.dispatchEvent(new Event('input', { bubbles:true }));
      qtyInput.dispatchEvent(new Event('change', { bubbles:true }));
    }
    if (els.qtyVal) els.qtyVal.textContent = v;
  }

  /* ---------------- Sticky bar UI ---------------- */
  const bar = document.createElement('div');
  bar.id = 'sticky-cart';
  bar.setAttribute('role', 'region');
  bar.setAttribute('aria-label', 'Order actions');

  bar.innerHTML = `
    <div class="sticky-inner">
      <!-- Row 1: Back + Step + Progress + Pills -->
      <div class="ue-steps">
        <button type="button" id="ue-back" class="ue-back" aria-label="Go back">← Back</button>
        <div class="ue-steptext" id="ue-step" aria-live="polite">Step 1 of 1</div>
        <div class="ue-progress"><span id="ue-fill" style="width:0%"></span></div>
        <div id="ue-pills" class="ue-pills" aria-hidden="true"></div>
      </div>

      <!-- Live selection chips (scrollable on mobile) -->
      <div id="ue-chips" class="ue-chips" aria-live="polite" hidden></div>

      <!-- Row 2: Microcopy + Qty + CTA + Trust -->
      <div class="ue-row2">
        <div class="ue-next" id="ue-next-copy">Takes ~60s • Price updates live</div>
        <div class="ue-row2-inner">
          <div class="ue-qty" id="ue-qty" aria-label="Quantity selector">
            <button type="button" aria-label="Decrease quantity">−</button>
            <span id="ue-qty-val" aria-live="polite">1</span>
            <button type="button" aria-label="Increase quantity">+</button>
          </div>
          <button id="sticky-submit" type="button" class="sticky__btn ue-cta-glow" aria-live="polite">GET STARTED</button>
        </div>
        <div class="ue-trustbar" id="ue-trustbar" aria-hidden="true">Free delivery • Taxes included • Pause anytime</div>
      </div>

      <div id="sticky-error" role="alert" aria-live="polite" class="ue-error" style="display:none;"></div>
    </div>
  `;
  document.body.appendChild(bar);
  document.body.classList.add('has-sticky-cart');

  const els = {
    bar,
    submit: $('#sticky-submit'),
    qtyBox: $('#ue-qty'),
    qtyVal: $('#ue-qty-val'),
    back:   $('#ue-back'),
    step:   $('#ue-step'),
    fill:   $('#ue-fill'),
    chips:  $('#ue-chips'),
    pills:  $('#ue-pills'),
    error:  $('#sticky-error')
  };

  /* ---------------- Qty controls ---------------- */
  els.qtyBox?.addEventListener('click', (e) => {
    if (!qtyInput || e.target.tagName !== 'BUTTON') return;
    const dir = e.target.textContent.trim() === '+' ? 1 : -1;
    setQty(getQty() + dir);
  });

  /* ---------------- State ---------------- */
  let hasStarted = false;
  function markStarted(){
    hasStarted = true;
    els.submit.classList.remove('ue-cta-glow');
    syncButtonLabel();
  }

  /* ---------------- Enable/disable logic ---------------- */
  function syncEnabled() {
    const tepoBtn = getTepoSubmit();
    let disabled = false;

    if (tepoBtn) {
      disabled =
        tepoBtn.disabled ||
        tepoBtn.getAttribute('aria-disabled') === 'true' ||
        tepoBtn.classList.contains('disabled');
      const root = getTepoRoot();
      if (!disabled && root) {
        const invalid = root.querySelector('[required]:invalid, .tcustomizer-error, .tepo-error, .has-error');
        if (invalid) disabled = true;
      }
    } else {
      const idInput = productForm && (productForm.querySelector('input[name="id"][value]:not([value=""])') ||
                                      productForm.querySelector('select[name="id"]'));
      if (!idInput) disabled = true;
      if (idInput && idInput.tagName === 'SELECT' && !idInput.value) disabled = true;
      const themeBtn = document.querySelector('form[action*="/cart/add"] [name="add"]');
      if (themeBtn && (themeBtn.disabled || themeBtn.textContent.toLowerCase().includes('sold'))) disabled = true;
    }

    if (els.submit.disabled !== disabled) {
      els.submit.disabled = disabled;
      els.submit.classList.toggle('disabled', disabled);
      els.submit.setAttribute('aria-disabled', String(disabled));
    }
  }

  /* ---------------- Button label ---------------- */
  function syncButtonLabel() {
    if (!hasStarted && getTepoRoot()) { els.submit.textContent = 'GET STARTED'; return; }
    const raw = readLivePriceRaw();
    const money = prettyMoney(raw);
    els.submit.textContent = `Buy now ${money}`;
  }

  /* ---------------- TEPO guided flow ---------------- */
  function tepoRootOnly(){
    return document.querySelector('[id^="tcustomizer-form-container-"]') ||
           document.querySelector('.tcustomizer-product-form') ||
           document.querySelector('.tcustomizer-widget');
  }
  function isVisible(el){
    if (!el) return false;
    const cs = getComputedStyle(el);
    if (cs.display==='none'||cs.visibility==='hidden'||+cs.opacity===0) return false;
    const r = el.getBoundingClientRect(); return r.width>0 && r.height>0;
  }
  function isSelectableField(field){
    if (!field) return false;
    const cls = (field.className||'').toLowerCase();
    if (cls.includes('heading')||cls.includes('description')||cls.includes('divider')) return false;
    return !!field.querySelector('input[type="radio"], input[type="checkbox"], select, .tcustomizer__option, .tcustomizer__value');
  }
  function fieldsList(){
    const root = tepoRootOnly(); if (!root) return [];
    return Array.from(root.querySelectorAll('.tcustomizer-field')).filter(isVisible).filter(isSelectableField);
  }

  let ueFields = [];
  let ueIndex  = 0;

  function paintStep(){
    if (!ueFields.length) return;
    ueIndex = Math.max(0, Math.min(ueIndex, ueFields.length-1));
    ueFields.forEach((f,i)=>{
      if (i < ueIndex) { f.classList.add('is-collapsed'); f.classList.remove('is-active'); }
      else if (i === ueIndex) { f.classList.remove('is-collapsed'); f.classList.add('is-active'); }
      else { f.classList.add('is-collapsed'); f.classList.remove('is-active'); }
    });
    els.step.textContent = `Step ${ueIndex+1} of ${ueFields.length}`;
    els.fill.style.width = Math.round(((ueIndex+1)/ueFields.length)*100) + '%';
    els.back.disabled = ueIndex === 0;

    paintPills();
  }

  function scrollToField(field){
    const bottomBar = document.getElementById('sticky-cart');
    const offset = (bottomBar ? bottomBar.getBoundingClientRect().height : 0) + 12;
    const rect = field.getBoundingClientRect();
    const topTarget = Math.max(0, rect.top + window.scrollY - offset);
    window.scrollTo({ top: topTarget, behavior: 'smooth' });
    field.classList.add('tepo-focus-flash');
    setTimeout(()=>field.classList.add('tepo-focus-flash-remove'), 800);
    setTimeout(()=>field.classList.remove('tepo-focus-flash','tepo-focus-flash-remove'), 1400);
  }

  function nextSelectableField(fromField) {
    const root = tepoRootOnly(); if (!root) return null;
    let f = fromField ? fromField.nextElementSibling : null;
    while (f) {
      if (f.classList?.contains('tcustomizer-field') && isVisible(f) && isSelectableField(f)) return f;
      f = f.nextElementSibling;
    }
    const all = Array.from(root.querySelectorAll('.tcustomizer-field')).filter(isVisible).filter(isSelectableField);
    if (!fromField) return all[0] || null;
    const idx = all.indexOf(fromField);
    return idx >= 0 ? all[idx + 1] || null : all[0] || null;
  }

  function setupGuidedScroll() {
    const root = tepoRootOnly(); if (!root) return;
    const advanceUIAndScroll = (field) => {
      if (!hasStarted) markStarted();
      const next = nextSelectableField(field);
      if (!next) return;
      ueFields = fieldsList();
      const idx = ueFields.indexOf(next);
      if (idx >= 0) { ueIndex = idx; paintStep(); }
      scrollToField(next);
      updateChips();
      buzz(12);
    };
    function shouldAdvance(target, field) {
      const t = (target.type || '').toLowerCase();
      if (t === 'radio' || target.tagName === 'SELECT') return true;
      if (t === 'checkbox') {
        const looksSingle =
          (field.dataset?.type || '').toLowerCase().includes('radiobutton') ||
          field.getAttribute('data-max') === '1' || field.dataset?.max === '1';
        return looksSingle;
      }
      return false;
    }
    root.addEventListener('change', (e) => {
      const tgt = e.target;
      const field = tgt?.closest?.('.tcustomizer-field');
      if (!field || !isSelectableField(field)) return;
      if (!shouldAdvance(tgt, field)) { updateChips(); return; }
      setTimeout(() => advanceUIAndScroll(field), 150);
    });
    root.addEventListener('click', (e) => {
      const card = e.target.closest?.('.tcustomizer__option, .tcustomizer__value');
      if (!card) return;
      const field = card.closest('.tcustomizer-field');
      if (!field || !isSelectableField(field)) return;
      const looksSingle =
        (field.dataset?.type || '').toLowerCase().includes('radiobutton') ||
        field.getAttribute('data-max') === '1' || field.dataset?.max === '1';
      if (!looksSingle) return;
      setTimeout(() => advanceUIAndScroll(field), 150);
    });
  }

  /* ---------------- Native add-to-cart → checkout ---------------- */
  async function nativeAddToCartCheckout() {
    if (!productForm) throw new Error('Product form not found.');
    if (qtyInput) {
      const q = String(getQty());
      const qEl = productForm.querySelector('input[name="quantity"], quantity-input input') || qtyInput;
      if (qEl) { qEl.value = q; qEl.dispatchEvent(new Event('change', { bubbles:true })); }
    }
    const idEl =
      productForm.querySelector('input[name="id"][value]:not([value=""])') ||
      productForm.querySelector('select[name="id"]');
    if (!idEl || !idEl.value) throw new Error('Please select a variant.');
    const fd = new FormData();
    fd.append('id', idEl.value);
    fd.append('quantity', String(getQty()));
    const res = await fetch('/cart/add.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: fd
    });
    if (!res.ok) {
      const err = await res.json().catch(()=>({}));
      throw new Error(err && err.description ? err.description : 'Add to cart failed.');
    }
    return res.json();
  }

  function showError(msg) {
    if (!els.error) return;
    els.error.style.display = 'block';
    els.error.textContent = msg;
    setTimeout(()=>{ els.error.style.display='none'; }, 5000);
  }

  /* ---------------- Chips (live selection summary) ---------------- */
  function updateChips(){
    const root = getTepoRoot(); if(!root || !els.chips) return;
    const allActiveFields = Array.from(root.querySelectorAll('.tcustomizer-field')).filter(isVisible);
    const picks = [];
    allActiveFields.forEach(f=>{
      const title = f.querySelector('.tcustomizer__title, .tcustomizer__heading')?.textContent?.trim();
      const radios = Array.from(f.querySelectorAll('input[type=radio]:checked')).map(i => i.closest('.tcustomizer__option, label')?.textContent?.trim() || i.value);
      const checks = Array.from(f.querySelectorAll('input[type=checkbox]:checked')).map(i => i.closest('.tcustomizer__option, label')?.textContent?.trim() || i.value);
      const selects = Array.from(f.querySelectorAll('select')).map(s => s.selectedOptions[0]?.text?.trim()).filter(Boolean);
      const values = [...radios, ...checks, ...selects].filter(Boolean);
      if (title && values.length) picks.push(`${title}: ${values.join(', ')}`);
    });
    els.chips.hidden = picks.length === 0;
    const isPhone = window.matchMedia('(max-width: 480px)').matches;
    const maxChips = isPhone ? 4 : 8;
    els.chips.innerHTML = picks.slice(0, maxChips).map(t=>`<span class="ue-chip">${t}</span>`).join('');
    if (picks.length > maxChips) {
      els.chips.insertAdjacentHTML('beforeend', `<span class="ue-chip ue-chip-more">+${picks.length - maxChips} more</span>`);
    }
  }

  /* ---------------- Price snackbar ---------------- */
  let lastMoney = '';
  let toastBusy = false;
  function priceToast(){
    const raw=readLivePriceRaw(); const money=prettyMoney(raw);
    if(!money || money===lastMoney) return;
    lastMoney = money;
    if (toastBusy) return;
    toastBusy = true;
    const t=document.createElement('div');
    t.className='ue-toast';
    t.textContent='New total: '+money;
    document.body.appendChild(t);
    requestAnimationFrame(()=> t.classList.add('show'));
    setTimeout(()=>{ t.classList.remove('show'); setTimeout(()=>{ t.remove(); toastBusy=false; }, 280); }, 1400);
  }

  /* ---------------- Haptics ---------------- */
  function buzz(ms=18){ if('vibrate' in navigator) try{ navigator.vibrate(ms); }catch(e){} }

  /* ---------------- Coach-mark pills ---------------- */
  function paintPills(){
    if (!els.pills) return;
    if (!ueFields.length) { els.pills.innerHTML=''; return; }
    const isPhone = window.matchMedia('(max-width: 480px)').matches;
    const max = isPhone ? 5 : 12;
    const out = ueFields.slice(0, max).map((_,i)=>`<span class="ue-pill ${i===ueIndex?'is-active':''}">${i+1}</span>`).join('');
    const extra = ueFields.length > max ? `<span class="ue-pill ue-pill-more">+${ueFields.length-max}</span>` : '';
    els.pills.innerHTML = out + extra;
  }

  /* ---------------- Inline error nudge ---------------- */
  function firstInvalid(){
    const root=getTepoRoot(); if(!root) return null;
    const invalid = root.querySelector('[required]:invalid, .tcustomizer-error, .tepo-error, .has-error');
    return invalid ? invalid.closest('.tcustomizer-field') : null;
  }
  function nudge(field,msg='Please complete this step'){
    if (!field) return;
    const note=document.createElement('div');
    note.className='ue-nudge';
    note.textContent=msg;
    field.appendChild(note);
    setTimeout(()=>note.remove(), 2600);
  }

  /* ---------------- CTA click behavior ---------------- */
  els.submit.addEventListener('click', async () => {
    try {
      buzz(12);
      const tepoBtn = getTepoSubmit();
      const hasTEPO = !!getTepoRoot();

      // If an invalid field exists, jump there first
      const bad=firstInvalid();
      if (bad) { scrollToField(bad); nudge(bad); return; }

      // If TEPO present but not started → guide to first selectable field
      if (hasTEPO && !hasStarted) {
        ueFields = fieldsList();
        const first = ueFields[0];
        if (first) {
          markStarted();
          ueIndex = 0; paintStep();
          scrollToField(first);
          updateChips();
          return;
        }
      }

      // TEPO present and started → delegate to TEPO (validations + add)
      if (tepoBtn) {
        if (qtyInput) setQty(getQty());
        ['pointerdown','mousedown','mouseup','click'].forEach(type => {
          tepoBtn.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
        });
        return;
      }

      // Native fallback (no TEPO)
      markStarted();
      await nativeAddToCartCheckout();
      window.location.href = '/checkout';

    } catch (e) {
      console.error(e);
      showError(e.message || 'Something went wrong.');
    }
  });

  /* ---------------- Init & boot sequence ---------------- */
  let tickInterval = null;
  function tick() {
    syncButtonLabel();
    if (qtyInput && els.qtyVal) els.qtyVal.textContent = getQty();
    syncEnabled();
    priceToast();
  }

  function init() {
    if (!productForm) return;
    if (qtyInput && els.qtyVal) els.qtyVal.textContent = getQty();
    els.bar.style.display = 'block';
    tick();

    // Start periodic tick
    tickInterval = setInterval(tick, 650);
    document.addEventListener('change', tick, { passive: true });
    document.addEventListener('input',  tick, { passive: true });
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearInterval(tickInterval); tickInterval=null; }
      else if (!tickInterval) { tick(); tickInterval = setInterval(tick, 650); }
    });

    // Steps bootstrap (only when TEPO exists)
    (function bootSteps(){
      let tries = 0;
      const t = setInterval(()=>{
        if (!getTepoRoot()) { clearInterval(t); return; } // abort if no TEPO
        ueFields = fieldsList();
        if (ueFields.length){
          clearInterval(t);
          ueIndex = 0;
          paintStep();
          // Back handler
          els.back.addEventListener('click', ()=>{
            if (!hasStarted) return;
            ueFields = fieldsList();
            ueIndex = Math.max(0, ueIndex-1);
            paintStep();
            scrollToField(ueFields[ueIndex]);
            updateChips();
            buzz(12);
          });
          // Wire guided scroll
          setupGuidedScroll();
          // Show chips container
          els.chips.hidden = false;
          updateChips();
        }
        if (++tries > 120) clearInterval(t); // ~30s max
      }, 250);
    })();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* ---------- Optional: shorten very long TEPO helper texts ---------- */
  document.addEventListener('DOMContentLoaded', () => {
    const root = getTepoRoot();
    if (!root) return;

    // Smart default + "Recommended" badge
    const popular = root.querySelector('[data-recommend="true"] input[type=radio]');
    if (popular && !popular.checked){ popular.click(); }
    const badgeHost = popular?.closest('.tcustomizer__option');
    if (badgeHost && !badgeHost.querySelector('.ue-reco')) {
      const b = document.createElement('div');
      b.className = 'ue-reco';
      b.textContent = 'Recommended';
      badgeHost.appendChild(b);
    }

    // Truncate long helper texts
    root.querySelectorAll('.tcustomizer__description, .tcustomizer__help').forEach(el => {
      const txt = (el.textContent || '').trim();
      if (txt.length < 140) return;
      const short = txt.slice(0, 140) + '… ';
      const more = document.createElement('a');
      more.href = '#'; more.textContent = 'More';
      more.className = 'ue-more';
      more.addEventListener('click', (e) => { e.preventDefault(); el.textContent = txt; });
      el.textContent = short; el.appendChild(more);
    });

    // Save & resume selections
    restoreSelections();
    root.addEventListener('change', persistSelections, { passive:true });
    root.addEventListener('input',  persistSelections, { passive:true });
  });

  // Micro tap bounce on click/tap
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('#sticky-submit');
    if (!btn) return;
    btn.classList.remove('ue-tap');
    requestAnimationFrame(() => {
      btn.classList.add('ue-tap');
      setTimeout(() => btn.classList.remove('ue-tap'), 260);
    });
  }, { passive: true });

  /* ---------- Hand pointer highlight (kept) ---------- */
  (function handPointer() {
    const DISMISS_KEY = 'ue_hand_dismissed';
    if (sessionStorage.getItem(DISMISS_KEY) === '1') return;

    const targetEl = els.submit;
    if (!targetEl) return;

    // Spotlight pulse on CTA (pure CSS)
    targetEl.classList.add('ue-spotlight');

    // Floating 👇 pointer
    const hand = document.createElement('div');
    hand.id = 'ue-hand-pointer';
    hand.textContent = '👇';
    document.body.appendChild(hand);

    function place() {
      const r = targetEl.getBoundingClientRect();
      const sizePx = Math.max(48, Math.min(window.innerWidth * 0.08, 120));
      const x = r.left + r.width/2 - sizePx*0.15;
      const y = r.top - sizePx*0.65;
      hand.style.left = x+'px';
      hand.style.top  = y+'px';
    }
    place();
    window.addEventListener('resize', place, { passive: true });
    window.addEventListener('scroll', place, { passive: true });

    // Dismiss on first CTA click
    targetEl.addEventListener('click', () => {
      sessionStorage.setItem(DISMISS_KEY, '1');
      hand.remove();
      targetEl.classList.remove('ue-spotlight');
    }, { once: true });
  })();

  /* ---------- Save & Resume ---------- */
  const STATE_KEY = 'ue_tepo_state';
  function persistSelections(){
    const form=getTepoRoot(); if(!form) return;
    const data=[...form.querySelectorAll('input:checked, select')].map(el=>{
      const name = el.name || el.id || '';
      let v = '';
      if (el.tagName==='SELECT') v = el.value;
      else if (el.type==='checkbox' || el.type==='radio') v = el.checked;
      else v = el.value || '';
      return {n:name, t:el.type||el.tagName, v};
    });
    sessionStorage.setItem(STATE_KEY, JSON.stringify(data));
  }
  function restoreSelections(){
    const form=getTepoRoot(); if(!form) return;
    const raw=sessionStorage.getItem(STATE_KEY); if(!raw) return;
    try{
      const data=JSON.parse(raw);
      data.forEach(({n,t,v})=>{
        const el=form.querySelector(`[name="${CSS.escape(n)}"],#${CSS.escape(n)}`);
        if(!el) return;
        if(el.tagName==='SELECT'){ el.value=v; el.dispatchEvent(new Event('change',{bubbles:true})); }
        else if(t==='checkbox' || t==='radio'){ el.checked=!!v; el.dispatchEvent(new Event('change',{bubbles:true})); }
        else { el.value=v; el.dispatchEvent(new Event('input',{bubbles:true})); }
      });
      updateChips();
    }catch(e){}
  }
// Ensure CTA text is white in all states (loads last in <head>)
(function forceCTAWhiteText(){
  const css = `
    #sticky-cart .sticky__btn,
    #sticky-cart .sticky__btn:hover,
    #sticky-cart .sticky__btn:focus-visible,
    #sticky-cart .sticky__btn:active,
    #sticky-cart .sticky__btn.ue-cta-glow,
    #sticky-cart .sticky__btn.disabled {
      background-color: #E23744 !important;
      border-color: #E23744 !important;
      color: #FFFFFF !important;
    }
    #sticky-cart .sticky__btn *,
    #sticky-cart .sticky__btn:hover *,
    #sticky-cart .sticky__btn:focus-visible *,
    #sticky-cart .sticky__btn:active *,
    #sticky-cart .sticky__btn.ue-cta-glow *,
    #sticky-cart .sticky__btn.disabled * {
      color: #FFFFFF !important;
      fill: #FFFFFF !important;
      stroke: #FFFFFF !important;
    }
  `;
  const s = document.createElement('style');
  s.id = 'ue-cta-white-text';
  s.appendChild(document.createTextNode(css));
  document.head.appendChild(s);
})();

})();
